(function() {
	function maketableContents() {
		var idcount = 1;
		var tableContents = '';
		var h2cnt = 0;
    var h3cnt = 0;
    var h4cnt = 0;
   	var currentlevel = 0;
    var matches = document.querySelectorAll('.columnDetailWap h2, .columnDetailWap h3');
    var tableContentsWrap = document.getElementById('js-tableContents');
    if(matches){
      matches.forEach(function (i) {
        i.id = 'chapter-' + idcount;
        idcount ++;
        var level = 0;
        var chapNo;
        if(i.nodeName.toLowerCase() == 'h2') {
          level = 1;
          h2cnt++;
          h3cnt = 0;
          h4cnt = 0;
          chapNo = h2cnt + ".";
        } else if(i.nodeName.toLowerCase() == 'h3') {
          level = 2;
          h3cnt++;
          h4cnt = 0;
          chapNo = h2cnt + "-" + h3cnt + ".";
        } else if(i.nodeName.toLowerCase() == 'h4') {
          level = 3;
          h4cnt++;
          chapNo = h2cnt + "-" + h3cnt + "-" + h4cnt + ".";
        }
        while(currentlevel < level) {
          tableContents += '<ol class="chapter">';
          currentlevel ++;
        }
        while(currentlevel > level) {
          tableContents += '</ol>';
          currentlevel --;
        }
        tableContents += '<li><a href="#' + i.id + '">' + chapNo + i.textContent + '</a></li>\n';
      });
    
      while(currentlevel > 0) {
        tableContents += '</ol>';
        currentlevel --;
      }	
        
      strtableContents = '<h2>目次</h2>\
             <div class="tableContentsInner">'
              + tableContents +
             '<!-- /.tableContentsInner --></div>';

      if(tableContentsWrap){
        tableContentsWrap.innerHTML = strtableContents;
      }      
    }
	}
	maketableContents();
})();


